import { t } from "i18next";
import React from "react";
import MapsRoute from "../../../../../../component/maps/MapsRoute";
import { Pagination, Skeleton } from "antd";
import style from "../../../AllTrip/AllTripAdd.module.css";

const TabDeliveryAssociate = ({
  delivAso,
  route,
  directions,
  depotLong,
  depotLat,
  skeleton,
  card,
  pageMap,
  handlePaginationMap,
}) => {
  return (
    <div className="flex">
      <div className="gap-[40px] mb-[24px] w-full">
        {/* Tab Title */}
        <h3 className="font-roboto text-[18px] font-semibold mb-[1.5rem] mt-2 w-full">
          {t("Delivery  Associate Detail")}
        </h3>

        {/* Content Tab */}
        <div className="flex w-full">
          {/* //one */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Delivery Associate ID")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {delivAso?.delivery_associate_id
                  ? delivAso?.delivery_associate_id
                  : "-"}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Last Name")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {delivAso?.last_name ? delivAso?.last_name : "-"}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Vehicle Number")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {delivAso?.vehicle_number ? delivAso?.vehicle_number : "-"}
              </h4>
            </div>
          </div>
          {/* line two */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Driver ID")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {delivAso?.driver_id ? delivAso?.driver_id : "-"}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Vehicle ID")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {delivAso?.vehicle_id ? delivAso?.vehicle_id : "-"}
              </h4>
            </div>
          </div>
          {/* line three */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("First Name")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {delivAso?.first_name ? delivAso?.first_name : "-"}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Vehicle Model")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {delivAso?.vehicle_model ? delivAso?.vehicle_model : "-"}
              </h4>
            </div>
          </div>
        </div>

        {/* Maps */}
        {skeleton ? (
          <Skeleton active />
        ) : (
          <div className="w-full mb-[50px]">
            <MapsRoute
              data={route}
              datas={card[pageMap - 1]}
              directions={directions}
              long={
                pageMap === 1
                  ? Number(depotLong)
                  : Number(
                      card[pageMap - 2][card[pageMap - 2]?.length - 1].longitude
                    )
              }
              lat={
                pageMap === 1
                  ? Number(depotLat)
                  : Number(
                      card[pageMap - 2][card[pageMap - 2]?.length - 1].latitude
                    )
              }
            />
            <div id={"pageMap"} className={style.Wrap + " justify-end flex"}>
              <div className="font-semibold text-base text-[#1D1D1D]">
                {card[pageMap - 1]?.length} Of {route?.length} Order
              </div>
              <Pagination
                onShowSizeChange={false}
                size="small"
                current={pageMap}
                defaultCurrent={pageMap}
                pageSize={25}
                total={route?.length}
                onChange={(value) => handlePaginationMap(value, 25)}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TabDeliveryAssociate;
